
<template>

  <div class="header-outer" :style="{'height': mobile ? '110px' : '70px'}">
    <div class="header-tab" v-if="!mobile">
      <img :src="logoUrl" />
    </div>
    <div class="mobile-header-bar" v-if="mobile">
      <img class="header-logo" :src="logoUrl" />
      <img src="@/assets/tridot.png" @click="$store.dispatch('togSettings')" />
    </div>
    <div class="main-header" :style="{'max-width': mobile ? '100%' : '600px'}">
      <v-popover trigger="hover" class="header-icon" v-if="header.type == 'floor'">
        <div class="header-icon">
          <img :src="headerIcon()" />
          <h6 style="white-space:nowrap;">{{header.title.length < 15 ? header.title : header.title.substring(0, 12) + '...'}}</h6>
        </div>
        <template slot="popover">
          <hover-component :options="floorBldgHoverOptions()"></hover-component>
        </template>
      </v-popover>
      <div class="header-icon" v-if="header.type != 'floor'">
        <img :src="headerIcon()" />
        <h6>{{header.title.length < 15 ? header.title : header.title.substring(0, 12) + '...'}}</h6>
      </div>
      <div class="header-title">
        <h1>{{header.lgText}}</h1>
        <h5 v-html="header.smText" v-if="$store.state.lang === 'en'">{{header.smText}}</h5>
        <h5 v-else>{{setLangText(header.smText)}}</h5>
      </div>
      <div class="header-alerts">
        <h4 class="header-bad">{{header.alerts ? header.alerts.bad : 0}}</h4>
        <img :src="alertIconUrl"/>
        <h4 class="header-crit">{{header.alerts ? header.alerts.crit : 0}}</h4>
        <v-popover offset="16" trigger="hover">
          <div class="header-hover"></div>
          <template slot="popover">
            <hover-component :options="alertHoverOptions()"></hover-component>
          </template>
        </v-popover>
      </div>
    </div>
    <div class="multi-header-tab" v-if="!mobile">
      <v-popover trigger="hover" style="height:30px;">
        <img style="height:30px;" class="tutorial-tog" :src="require(`@/assets/tooltip${tutorial ? 'Active' : 'Inactive'}.png`)" @click="$store.dispatch('toggleTutorial')"/>
        <template slot="popover">
          <hover-component :options="tutorialOptions()"></hover-component>
        </template>
      </v-popover>
      <div class="user-initials">
        <h5>{{$store.state.user.firstName[0].toUpperCase()}}{{$store.state.user.lastName[0].toUpperCase()}}</h5>
      </div>
      <img src="@/assets/tridot.png" @click="$store.dispatch('togSettings')" />
      <img src="@/assets/logout.png" @click="$router.push({path: '/'})" />
    </div>
  </div>

</template>

<script>

import { mapState } from 'vuex';
import Lang from '@/lib/langTemplates/SettingsTemplate';

import AlertHover from '../hover/Hover';

export default {

  data(){
    return {
      mobile: false,
      logoUrl: 'https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/pro-box.png',
      alertIconUrl: 'https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/alert.png'
    }
  },

  computed: {
    header(){
      return this.$store.state.header;
    },
    clauses(){
      let lPref = this.$store.state.lang;
      return Object.keys(Lang.clauses).reduce((a, i) => {
        a[i] = Lang.clauses[i][lPref];
        return a;
      }, {});
    },
    tutorial(){
      return this.$store.state.user.tutorial;
    }
  },

  components: {
    'hover-component': AlertHover
  },

  methods: {

    headerIcon(){
      let img;
      switch (this.header.type) {
        case 'org':
          img = 'enterprise';
        break;
        case 'bldg':
          img = 'company';
        break;
        case 'floor':
          img = 'tilesWhite';
        break;
        case 'room':
          img = 'doorWhite';
        break;
      }
      return `https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/${img}.png`
    },

    setLangText(t){
      if (t.includes('Building')) {
        return this.clauses.bldgMonitored;
      } else if (t.includes('Floor')) {
        return this.clauses.floorMonitored;
      } else if (t.includes('Room')) {
        return this.clauses.roomMonitored.replace('Room', 'Area');
      } else {
        return '';
      }
    },

    alertHoverOptions(){
      return {
        type: 'full',
        temp: 'Util',
        instance: 'Current Alerts',
        replacers: [{from: 'warn', to: this.header.alerts ? this.header.alerts.bad : 0}, {from: 'crit', to: this.header.alerts ? this.header.alerts.crit : 0}]
      }
    },

    setHoverDelay(){
      return {show: 1500, hide: 100};
    },

    floorBldgHoverOptions(){
      return {
        type: 'mini',
        text: this.$store.getters.getActiveBuilding().info.name,
        exception: true
      }
    },

    tutorialOptions(){
      return {
        type: 'mini',
        text: `Tooltip ${this.tutorial ? '<span style="color:#00f600;">ON</span>' : '<span style="color:red">OFF</span>'}`,
        exception: true
      }
    }

  },

  mounted(){
    this.mobile = (this.$screen.breakpoint !== 'sm' || this.$screen.width >= 1000) ? false : true;
  },

  watch: {
    '$screen.width': function(newData, oldData){
      this.mobile = (this.$screen.breakpoint !== 'sm' || this.$screen.width >= 1200) ? false : true;
    }
  }

}

</script>

<style>

.header-outer {
  width: 100vw;
  top: 0px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.mobile-header-bar {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #1A2839;
  border-bottom: 2px solid rgb(0, 153, 191);
}

.mobile-header-bar img {
  height: 20px;
  margin-right: 3.5%;
}

.header-logo {
  height: 98%;
  margin-right: 0px;
  margin-left: 3.5%;
}

.main-header {
  width: 100%;
  max-width: 600px;
  height: 60px;
  background-color: #325468;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-icon {
  height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 3%;
}

.header-icon img {
  height: 50%;
}

.header-icon h6 {
  margin: 2px;
}

.header-title {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: light;
}

.header-title h1 {
  margin: 5px;
}

.header-title h5 {
  margin: 0px;
}

.header-alerts {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 3%;
  position: relative;
}

.header-hover {
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
}

.header-alerts img {
  height: 70%;
}

.header-bad {
  color: yellow;
}

.header-crit {
  color: red;
}

.header-tab {
  height: 70px;
  position: absolute;
  left: 3%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
}

.multi-header-tab {
  height: 70px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15%;
  max-width: 230px;
  right: 1%;
  justify-content: space-around;
}

.header-tab img, .multi-header-tab img {
  height: 40%;
}

.tutorial-tog {
  cursor: pointer;
}

.multi-header-tab img {
  cursor: pointer;
}

.user-initials {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: -webkit-linear-gradient(rgb(0, 153, 191), #325468);
  border-radius: 100%;
}

.user-initials h5 {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px;
}

</style>



// WEBPACK FOOTER //
// src/components/util/Header.vue